module.exports = __webpack_public_path__ + "img/xinrenchoujiang.af05a69f.png";